import React, { useState } from "react";
import image from "../../asserts/promotion_image.png";
import "../../App.css";
import dayjs from "dayjs";
import userimg from "../../asserts/userprofile.png";
import { FaPhone, FaPhoneAlt } from "react-icons/fa";
import { TbMailFilled } from "react-icons/tb";
import { Modal, Popover } from "antd";
import { faEdit, faEllipsisVertical, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalPopup from "../Common/Modal/Modal";
import DeleteList from "../Offers/DeleteList";
import { Tooltip } from "antd";
import { capitalizeFirstLetter } from "../Common/Captilization";
import NoData from "../../asserts/no data.png";


export default function EmployeeGridView({
  currentData,
  SetUpdateData,
  EmployeeID,
  setEmployeeID,
  setModalIsOpen,
  setDeleteEmpModalIsOpen,
  deleteEmpmodalIsOpen,
}) {
  const apiImgUrl = process.env.REACT_APP_API_URL_IMAGE;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [hoverid, setHoverId] = useState("");
  const [changeColor, setChangeColor] = useState();
  const [openPopovers, setOpenPopovers] = useState({});
  const [userName, setUserName] = useState("")



  const user = sessionStorage.getItem("USER_ID");
  const loadCrud = () => {
  const raw = sessionStorage.getItem("crud_permission");
  if (!raw) {
    return ["create", "view", "update", "delete"];
  }
  return raw
    .split(",")
    .map(x => x.trim())
    .filter(Boolean);
};
const crud = loadCrud();
const canCreate = crud?.includes("create");
const canView   = crud?.includes("view");
const canUpdate = crud?.includes("update");
const canDelete = crud?.includes("delete");
  const handleEdit = (tbs_pro_emp_id) => {
    SetUpdateData(tbs_pro_emp_id);
    setEmployeeID(tbs_pro_emp_id);
    setModalIsOpen(true);
    togglePopover(tbs_pro_emp_id);
  };

  const handleDelete = (tbs_pro_emp_id) => {
    setEmployeeID(tbs_pro_emp_id);
    togglePopover(tbs_pro_emp_id);
    setDeleteEmpModalIsOpen(true);
  };

  const togglePopover = (tbs_pro_emp_id) => {
    setOpenPopovers((prevState) => ({
      ...prevState,
      [tbs_pro_emp_id]: !prevState[tbs_pro_emp_id],
    }));
  };

  const closeDeleteModal = () => {
    setDeleteEmpModalIsOpen(false);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const openModal = (event) => {
    // Get the image source (src) using `getElementById`
    const imageSrc = event.target.getAttribute('src');

    // Set the modal image source
    setModalImage(imageSrc);

    // Open the modal
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="pt-[0.5vw] px-[1vw]">
        { currentData?( 
        <div className="grid grid-cols-5 w-full gap-x-[2.5vw] gap-y-[1vw]">
          {currentData?.length > 0 &&
            currentData?.map((item) => {
              const fullname = `${item?.emp_first_name.charAt(0) === item?.emp_first_name.charAt(0)?.toLowerCase()
                ? capitalizeFirstLetter(item?.emp_first_name)
                : item?.emp_first_name} ${item?.emp_last_name}`;
              return (
                <div
                  className={`  bg-white h-[33.5vh] border-[#1f4b7f] border-l-[0.1vw]  border-r-[0.3vw] border-b-[0.3vw] border-t-[0.1vw] rounded-[0.5vw]`}
                  onMouseEnter={() => {
                    if (user?.startsWith("tbs-pro")) {
                      setHoverId(item.tbs_pro_emp_id);
                      console.log(item.tbs_pro_emp_id, "----owner id");
                    } else {
                      setHoverId(item.tbs_op_emp_id);
                      console.log(item.tbs_op_emp_id, "----op id");
                    }
                  }}
                  onMouseLeave={() => setHoverId("")}
                  style={{
                    transition: "ease-in 0.2s",

                    boxShadow:
                      hoverid === item.tbs_pro_emp_id || hoverid === item.tbs_op_emp_id
                        ? "0.5vw 0.5vw 0.5vw #1f4b7f"
                        : "none",
                  }}
                >
                  <div className="flex justify-center pl-[5vw] pt-[1vw]">
                    <img
                      src={`${item?.profile_img
                        ? `${apiImgUrl}${item?.profile_img}`
                        : userimg
                        } `}
                      alt="Profile"
                      className="w-[5vw] h-[10vh] object-cover cursor-pointer rounded-[0.2vw]"
                      onClick={openModal}
                    />
                    <div className="text-right pl-[3.5vw]">
                      <Popover
                        placement="bottomRight"
                        content={
                          <div className="flex flex-col p-[.5vw] border-[.1vw] border-[#1f487c] rounded-[.5vw]">
                            <div>
                              <a
                                onClick={() => {
                                  if(!canUpdate) return; 
                                  if (user?.startsWith("tbs-pro")) {
                                    handleEdit(item.tbs_pro_emp_id);
                                    console.log(
                                      item.tbs_pro_emp_id,
                                      "----owner id"
                                    );
                                  } else {
                                    handleEdit(item.tbs_op_emp_id);
                                    console.log(item.tbs_op_emp_id, "----op id");
                                  }
                                
                                }}
                                className={`flex items-center  text-[1vw] text-[#1F4B7F] hover:text-[#1f487c] ${canUpdate ? "cursor-pointer" : "cursor-not-allowed"}`}
                              >
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  className="mr-1"
                                  color="#1f487c"
                                />
                                Edit
                              </a>
                            </div>
                            <div className="">
                              <hr class="border-t-2 border-[#1F4B7F] my-[.3vw]" />
                            </div>
                            <div>
                              <a
                                onClick={() => {
                                  if(!canDelete) return 
                                  if (user?.startsWith("tbs-pro")) {
                                    handleDelete(item.tbs_pro_emp_id);
                                    setUserName(`${item.emp_first_name}${" "}${item.emp_last_name}`)
                                    console.log(
                                      item.tbs_pro_emp_id,
                                      "----owner id"
                                    );
                                  } else {
                                    handleDelete(item.tbs_op_emp_id);
                                    console.log(item.tbs_op_emp_id, "----op id");
                                    setUserName(`${item.emp_first_name}${" "}${item.emp_last_name}`)
                                  }
                                
                                }}
                                className={`flex pt-[0.1vw] items-center  text-[1vw] text-[#1F4B7F] hover:text-[#1f487c] ${canDelete ? "cursor-pointer" : "cursor-not-allowed"}`}
                              >
                                <FontAwesomeIcon
                                  icon={faTrash}
                                  className="mr-1"
                                  color="#1f487c"
                                />
                                Delete
                              </a>
                            </div>
                          </div>
                        }
                        trigger="click"
                        open={
                          openPopovers[
                          user?.startsWith("tbs-pro")
                            ? item.tbs_pro_emp_id
                            : item.tbs_op_emp_id
                          ] || false
                        }
                        onOpenChange={() =>
                          togglePopover(
                            user?.startsWith("tbs-pro")
                              ? item.tbs_pro_emp_id
                              : item.tbs_op_emp_id
                          )
                        }
                      >
                        <FontAwesomeIcon
                          icon={faEllipsisVertical}
                          color="#1f487c"
                          className={` text-[#1f4b7f] cursor-pointer rounded-[0.5vw]`}
                          // onMouseEnter={() => {
                          //   if (user?.startsWith("tbs-pro")) {
                          //     setHoverId(item.tbs_pro_emp_id);
                          //     console.log(item.tbs_pro_emp_id, "----owner id");
                          //   } else {
                          //     setHoverId(item.tbs_op_emp_id);
                          //     console.log(item.tbs_op_emp_id, "----op id");
                          //   }
                          // }}
                          // onMouseLeave={() => setHoverId("")}
                          style={{
                            height: "1.5vw",
                            width: "1.5vw",
                          }}
                        />
                      </Popover>
                    </div>
                  </div>
                  <div className="flex-col h-[19vh] flex items-center justify-center gap-y-[0.5vw]">
                    <h1 className="font-bold text-[1vw] mt-[.7vw] pt-[0.7vw] text-[#1f4b7f] ">
                      {/* {`${capitalizeFirstLetter(item.emp_first_name)} ${item.emp_last_name}`} */}
                      {
                        fullname?.length > 14 ? <Tooltip color="white"
                          overlayInnerStyle={{ color: "#1F4B7F" }} placement="top"
                          title={`${capitalizeFirstLetter(item?.emp_first_name)} ${item.emp_last_name}`}
                          className="cursor-pointer">{fullname?.slice(0, 14) + ".."}</Tooltip> : fullname
                      }
                    </h1>
                    <div className="flex flex-col  justify-center gap-y-[0.8vw] mt-[.5vw]">
                      <div className="flex flex-row items-center space-x-[0.5vw] ">
                        <div
                          className={`  bg-[#f6eeff] w-[1.8vw] h-[1.8vw] items-center flex justify-center rounded-lg`}
                          style={{
                            transition: "ease-out 1s",
                          }}
                        >
                          <FaPhoneAlt
                            size="1vw"
                            color={`${"#1f487c"
                              }`}
                          />
                        </div>
                        <div className="text-[0.9vw] text-[#1f4b7f]">{item?.phone === null || item?.phone?.length <= 0 ? "Not Available" : item.phone}</div>
                      </div>
                      <div className="flex flex-row items-center space-x-[0.5vw] ">
                        <div
                          className={`bg-[#f6eeff] w-[1.8vw] h-[1.8vw] items-center flex justify-center rounded-lg`}
                          style={{
                            transition: "ease-out 1s",
                          }}
                        >
                          <TbMailFilled
                            size="1vw"
                            color={`${"#1f487c"
                              }`}
                          />
                        </div>
                        {/* <div className="text-[0.9vw]">{item.email_id}</div> */}
                        {item?.email_id?.length > 18 ? (
                          <Tooltip
                            color="white"
                            overlayInnerStyle={{ color: "#1F4B7F" }}
                            placement="top"
                            title={item?.email_id}
                            className="cursor-pointer"
                          // color="#1F487C"
                          >
                            <div className="text-[0.9vw] text-[#1f4b7f]">
                              {" "}
                              {`${item?.email_id?.slice(0, 18)}...`}
                            </div>
                          </Tooltip>
                        ) : (
                          <div className="text-[0.9vw] text-[#1f4b7f]">
                            {/* {item?.email_id?.slice(0, 18)} */}
                            {item?.email_id === null || item?.email_id?.length <= 0 ? "Not Available" : item?.email_id?.slice(0, 18)}
                          </div>
                        )}
                      </div>
                      <i className="pi-ellipsis-v"></i>
                    </div>
                  </div>
                </div>
              )
            })}
        </div>):( <div className="grid grid-cols-1 mt-[15vw]">
          
            <div className="col-span-1 flex items-center justify-center text-gray-500">
              <img src={NoData}
            className="w-[3.5vw] h-[3.5vw] "/></div>
            <div className=" col-span-1 flex items-center justify-center font-medium text-[2vw] mt-[0.5vw] text-gray-500 ">
         No Data Found</div>
          </div>)}
      </div>
      <ModalPopup
        show={deleteEmpmodalIsOpen}
        onClose={closeDeleteModal}
        height="20vw"
        width="30vw"
        closeicon={false}
      >
        <DeleteList
          setDeleteModalIsOpen={setDeleteEmpModalIsOpen}
          content={"Want to delete this Employee"}
          title={`${capitalizeFirstLetter(userName)}`}
          api={
            user?.startsWith("tbs-pro")
              ? `${apiUrl}/pro-emp-personal-details/${EmployeeID}`
              : `${apiUrl}/emp-personal-details/${EmployeeID}`
          }
          module={"employee"}
        />
      </ModalPopup>
      <Modal
        className="flex justify-center"
        visible={isModalOpen}
        onCancel={closeModal}
        footer={null}
        centered
        width="20vw"
        height="20vw"
        bodyStyle={{ padding: 0 }}
        destroyOnClose={true} // Ensures modal is destroyed on close
      >
        {/* Display the image in the modal */}
        <div className="flex justify-center">
          {modalImage && (
            <img
              src={modalImage}
              alt="Gst Preview"
              // style={{ width: "20vw", height: "20vw" }}
              className="object-cover"
            />
          )}
        </div>
      </Modal>
    </>
  );
}
